import type { FaireProductEntity } from "../../entity_types/product";

export const p_uxf6nfz53h: FaireProductEntity = {
  token: "p_uxf6nfz53h",
  type: "product",
  name: "Vanilla - Lavender | Lip Balm | Zero Waste",
  brandToken: "b_7lde9s8e6u",
  brandName: "New Day Organics LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/ac40893665d4f98dc009eea71d405868393e748ef9fca5da3e4e15411eeb8968.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/257e99c3d80cfcfe7732668c3c3dd8724334c6497210dab54865544903311bbd.jpeg",
    "https://cdn.faire.com/fastly/7140d8e965b68dd978e0162679e7df2167262c921d2bea978ba26f424701f02a.jpeg",
    "https://cdn.faire.com/fastly/d73e9e89059792cfc25005fa7f64d99da95feca427c33301d208fc955a1206b8.jpeg",
  ],
  priceDollars: 9.98,
  description:
    "Vanilla - Lavender | Lip Balm | Zero Waste | Lip Treatment | Eco-Friendly | Vanilla Lip Balm | Soothe\nIt’s lip balm season and if you like the cozy, sweet aroma of vanilla, you are going to love our zero-waste, 0.3 oz Vanilla- Lavender lip balm in a compostable papertube!\n\nThis lip balm glides on easily to instantly soothe and protect your lips.\n\nMade with 100% organic, extra virgin coconut oil, cocoa butter, organic triple-filtered beeswax and triple-filtered organic beeswax, this lip balm is luxury for your lips like no other!\n\nCocoa butter and coconut oils, soothe and protect your lips from the elements. Sunflower seed oil and vitamin E provide additional anti-oxidant protection.\n\nI am in LOVE with the VANILLA and Lavender combination. Vanilla is the top flavor with a hint of the sweetness of the lavender. It’s lip-perfection!\n\nSOOTHE\nVanilla- Lavender Lip Balm | 0.3 oz\nINGREDIENTS: *",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:57.825Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
